import React, { Component } from 'react';
import { Radio } from '@material-ui/core';
import styles from './CustomRadio.module.css';

class CustomRadio extends Component {
  render() {
    const { ...props } = this.props;

    return (
      <Radio
        icon={<span className={styles.radioIcon} />}
        checkedIcon={<span className={styles.radioCheckedIcon} />}
        {...props}
      />
    );
  }
}

export default CustomRadio;
